/* ==========================================================================
   el'amore — theme behaviour
   Mirrors the interactions from the original design:
   mobile nav, toast on add-to-cart, tabbed product filter, testimonial
   switcher, accordions, quantity steppers and the product gallery.
   ========================================================================== */

(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  var routes = (window.elamoreRoutes || {});
  var strings = (window.elamoreStrings || {});

  /* ---------------------------------------------------------------- Toast */

  var toastEl = null;
  var toastTimer = null;

  function toast(message) {
    if (!message) return;
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = message;
    // force reflow so the transition replays on repeat adds
    void toastEl.offsetWidth;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 2600);
  }

  /* ----------------------------------------------------------- Cart count */

  function refreshCartCount() {
    return fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        return cart;
      })
      .catch(function () { /* offline / non-shop preview */ });
  }

  function addToCart(id, quantity, label) {
    var body = { items: [{ id: id, quantity: quantity || 1 }] };
    return fetch(routes.cart_add + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) {
          toast(res.data.description || res.data.message || strings.addError);
          return;
        }
        refreshCartCount();
        toast(label ? label + strings.addedSuffix : strings.added);
      })
      .catch(function () { toast(strings.addError); });
  }

  // Quick-add buttons on product cards
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-quick-add]');
    if (!btn) return;
    event.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    btn.disabled = true;
    addToCart(id, 1, btn.getAttribute('data-product-title')).then(function () {
      btn.disabled = false;
    });
  });

  /* ------------------------------------------------------------ Mobile nav */

  var navToggle = document.querySelector('[data-nav-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var navOverlay = document.querySelector('[data-nav-overlay]');

  function setNav(open) {
    if (!mobileNav) return;
    mobileNav.classList.toggle('is-open', open);
    if (navOverlay) navOverlay.classList.toggle('is-open', open);
    if (navToggle) navToggle.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
  }

  if (navToggle) navToggle.addEventListener('click', function () { setNav(!mobileNav.classList.contains('is-open')); });
  if (navOverlay) navOverlay.addEventListener('click', function () { setNav(false); });
  document.querySelectorAll('[data-nav-close]').forEach(function (el) {
    el.addEventListener('click', function () { setNav(false); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setNav(false); });

  /* ------------------------------------------------------------ Accordions */

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-accordion-trigger]');
    if (!trigger) return;
    var panel = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!panel) return;
    var isOpen = trigger.getAttribute('aria-expanded') === 'true';
    var group = trigger.closest('[data-accordion]');

    if (group && group.hasAttribute('data-accordion-single') && !isOpen) {
      group.querySelectorAll('[data-accordion-trigger]').forEach(function (other) {
        if (other === trigger) return;
        other.setAttribute('aria-expanded', 'false');
        var sign = other.querySelector('.accordion__sign');
        if (sign) sign.textContent = '+';
        var otherPanel = document.getElementById(other.getAttribute('aria-controls'));
        if (otherPanel) otherPanel.hidden = true;
      });
    }

    trigger.setAttribute('aria-expanded', String(!isOpen));
    panel.hidden = isOpen;
    var sign = trigger.querySelector('.accordion__sign');
    if (sign) sign.textContent = isOpen ? '+' : '−';
  });

  /* ------------------------------------------------ Product filter tabs */

  document.querySelectorAll('[data-tabs]').forEach(function (group) {
    var buttons = group.querySelectorAll('[data-tab]');
    var scope = document.getElementById(group.getAttribute('data-tabs-target')) || document;

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var value = button.getAttribute('data-tab');
        buttons.forEach(function (b) { b.classList.toggle('is-active', b === button); });
        scope.querySelectorAll('[data-tab-item]').forEach(function (item) {
          var cats = (item.getAttribute('data-tab-item') || '').split('|');
          item.hidden = value !== 'all' && cats.indexOf(value) === -1;
        });
      });
    });
  });

  /* -------------------------------------------------------- Testimonials */

  document.querySelectorAll('[data-testimonials]').forEach(function (group) {
    var avatars = group.querySelectorAll('[data-testimonial-avatar]');
    var panels = group.querySelectorAll('[data-testimonial-panel]');

    avatars.forEach(function (avatar, index) {
      avatar.addEventListener('click', function () {
        avatars.forEach(function (a, i) {
          a.classList.toggle('is-active', i === index);
          a.setAttribute('aria-selected', String(i === index));
        });
        panels.forEach(function (p, i) { p.hidden = i !== index; });
      });
    });
  });

  /* ------------------------------------------------------ Quantity input */

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-qty-change]');
    if (!button) return;
    var wrapper = button.closest('[data-qty]');
    var input = wrapper && wrapper.querySelector('input');
    if (!input) return;
    var step = parseInt(button.getAttribute('data-qty-change'), 10);
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var next = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------ Product gallery */

  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-image');
        var srcset = thumb.getAttribute('data-srcset');
        var alt = thumb.getAttribute('data-alt') || '';
        if (main && src) {
          main.src = src;
          main.alt = alt;
          if (srcset) main.srcset = srcset;
        }
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      });
    });
  });

  /* ----------------------------------------------- Variant selection (PDP) */

  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var variantsScript = form.querySelector('[data-variants]');
    if (!variantsScript) return;

    var variants;
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }

    var idInput = form.querySelector('[data-variant-input]');
    var priceEl = form.querySelector('[data-price]');
    var comparePriceEl = form.querySelector('[data-compare-price]');
    var submit = form.querySelector('[data-add-button]');
    var submitText = form.querySelector('[data-add-button-text]');
    var totalEl = form.querySelector('[data-total-label]');
    var qtyInput = form.querySelector('[data-qty] input');

    function currentOptions() {
      return Array.prototype.map.call(
        form.querySelectorAll('[data-option-index]'),
        function (fieldset) {
          var checked = fieldset.querySelector('input:checked');
          return checked ? checked.value : null;
        }
      );
    }

    function money(cents) {
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents, strings.moneyFormat);
      }
      return (strings.currencySymbol || '') + (cents / 100).toLocaleString(undefined, {
        minimumFractionDigits: 0, maximumFractionDigits: 2
      });
    }

    function update() {
      var selected = currentOptions();
      var match = variants.filter(function (variant) {
        return selected.every(function (value, index) {
          return value === null || variant.options[index] === value;
        });
      })[0];

      if (!match) {
        if (submit) submit.disabled = true;
        if (submitText) submitText.textContent = strings.unavailable;
        return;
      }

      if (idInput) idInput.value = match.id;

      if (priceEl) priceEl.textContent = money(match.price);
      if (comparePriceEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          comparePriceEl.textContent = money(match.compare_at_price);
          comparePriceEl.hidden = false;
        } else {
          comparePriceEl.hidden = true;
        }
      }

      if (submit) submit.disabled = !match.available;
      if (submitText) submitText.textContent = match.available ? strings.addToBag : strings.soldOut;

      if (totalEl) {
        var qty = parseInt(qtyInput && qtyInput.value, 10) || 1;
        totalEl.textContent = match.available ? ' — ' + money(match.price * qty) : '';
      }

      if (history.replaceState && match.available) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }

    form.addEventListener('change', update);
    if (qtyInput) qtyInput.addEventListener('input', update);
    update();
  });

  /* --------------------------------------------------- PDP AJAX add-to-cart */

  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      var idInput = form.querySelector('[data-variant-input]');
      var qtyInput = form.querySelector('[data-qty] input');
      if (!idInput || !idInput.value) return;

      event.preventDefault();
      var button = form.querySelector('[data-add-button]');
      if (button) button.disabled = true;

      addToCart(idInput.value, parseInt(qtyInput && qtyInput.value, 10) || 1, form.getAttribute('data-product-title'))
        .then(function () { if (button) button.disabled = false; });
    });
  });

  /* ------------------------------------------------------ Cart line updates */

  function changeCartLine(line, quantity) {
    return fetch(routes.cart_change + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function () { window.location.reload(); });
  }

  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-cart-remove]');
    if (!remove) return;
    event.preventDefault();
    changeCartLine(parseInt(remove.getAttribute('data-cart-remove'), 10), 0);
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-qty]');
    if (!input) return;
    changeCartLine(parseInt(input.getAttribute('data-cart-qty'), 10), parseInt(input.value, 10) || 0);
  });

  refreshCartCount();
})();
